export class AngularTransport {
	constructor(transport) {
		this._transport = transport;
		this._method = 'GET';
	}

	// TODO - output something Promises/A compatible
	fetch(url, data) {
		return this._transport({
			url: url,
			method: this._method,
			params: data
		});
	}

	setMethod(method) {
		this._method = method;
	}
}
